import React, {Component} from 'react';
import InstagramFeed  from 'react-ig-feed'
//import InstagramFeed from "./insta.js";


import 'react-ig-feed/dist/index.css'
//import 'index.css'

class Demo extends Component {
    
    
    render() {
       
            return (

<section className="pb-6">
    <div className="container">
        <div className="row">
            <div className="col-md-8 mx-auto">
                            <h2 className=" text-center text-md-left">Demo</h2>
                            </div>
                            
                            
        </div>
        <div className="">

                
                         {/*<InstagramFeed token="IGQVJXbWxwTHlVakZAVbU1wamtrcy1Bbl9XNU5seFhGa2ZAsc3hYUjVWVzRVYXBIUko2eWNJenVqZAjRHRGIyY19WWWFmcGpqeDhDam45U3dQN1FPOWdicm1RMkY4UUNiRzRvcHQ0MkpOOTBEa0JqLVhRZAwZDZD"  counter="6"/> */} 
                         <InstagramFeed token="IGQVJVU3U4ZAjljbGJEVkVVdnZAJOVBsYmlDdzZAlbWw5clk2TDJKRnBIRG5jQlFYanVLTThFV042MWpwdHFNTDBfUnR0OERQZAGZANZA2IwcG9uQjJKMmFSOGxaMk1qZAmxEUzdEb3FKNEYyX3hhYXZAQMlJuRgZDZD" counter="6"/>

            </div>
    </div>
</section>

                

            );

        }

    }


export default Demo;
